import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=4ddfb54c&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"
import style0 from "./DownloadView.vue?vue&type=style&index=0&id=4ddfb54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddfb54c",
  null
  
)

export default component.exports